import $ from 'jquery';

export const videoModalId = '#howToVideoModal';

const stopVideoOnModalExit = () => {
  $(videoModalId).on('hidden.bs.modal', function () {
    $(`${videoModalId} iframe`).removeAttr('src');
  });
};

export const initPlayYouTubeModal = () => {
  // const trigger = $('body').find('[data-toggle="modal"]');
  $('body').on('click', '.help-video', function () {
    $(`${videoModalId} iframe`).removeAttr('src');
    const videoUrl = $(this).attr('data-youtube-url');
    setTimeout(() => {
      $(`${videoModalId} iframe`).attr('src', videoUrl);
    }, 50);
  });
  stopVideoOnModalExit();
};
